import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { Link, useLocation } from 'react-router-dom';
import {
   Collapse,
   Navbar,
   Nav,
} from 'reactstrap';
import { toastr } from 'react-redux-toastr';

import UserDropDownMenu from 'app/employer/components/UserDropDownMenu';
import UpwardLogo from 'components/Logo';
import { toggleSidebar } from 'redux/actions/sidebarActions';
import authUtil from 'util/auth';
import { employerRole, partnerRole } from 'constants/roles';
import ImpersonationDropdown from './ImpersonationDropdown';
import OrganizationSwitch from './OrganizationSwitch';

/*
  Added in separate element for User Drop Down menu
  Removed un necessary code - still needs clean up
*/

const NavbarComponent = (props) => {
   const [anchorEl, setAnchorEl] = React.useState(null);

   // const [anchorEl, setAnchorEl] = useState(null);
   //
   // // showing message for maintenance
   // useEffect(() => {
   //    toastr.info(
   //       'Site Maintenance',
   //       'We\'re conducting maintenance to improve our system\'s performance and reliability. While we aim to minimize disruptions, certain features may be temporarily unavailable or have reduced functionality. We apologize for any inconvenience caused.\n' +
   //       'Our dedicated team will work diligently to complete the maintenance swiftly and minimize the impact on your daily operations. If you have urgent concerns or questions, please reach out to our support team, who will assist you throughout the process.\n' +
   //       'We sincerely appreciate your patience and understanding during this maintenance period. Your business is valuable to us, and we\'re committed to delivering the best possible service.\n' +
   //       'Thank you for your continued support.',
   //       {
   //          showCloseButton: true,
   //          closeOnToastrClick: true,
   //          timeOut: 0,
   //          position: 'top-center',
   //       },
   //    )
   // }, [])

   /*
    * DE shutdown: the tagline names the side the user is ON ("for partners" on the
    * partner portal, "for employers" only inside the DE section) - with DE retired,
    * branding the partner portal "for employers" was just confusing.
    */
   const location = useLocation();
   const sideLabel = location?.pathname?.startsWith('/employer') ? 'Employers' : 'Partners';

   const openEmployerMenu = (event) => {
      setAnchorEl(event.currentTarget);
   };

   const closeEmployerMenu = () => {
      setAnchorEl(null);
   };
   return (
      <Navbar
         fixed='top'
         className={ ((props.isImpersonating || props.isImpersonatingPartner) ? 'bg-light-orange' : process.env.REACT_APP_THEME_TOP_NAV_BG)}
         expand
      >
         <a className='sidebar-brand' href='/employers'>
            <UpwardLogo fill='#444'/>
         </a>
         {
            /*
             * DE shutdown: the side switcher is internal-only and only renders for a
             * LIVE DE session - it never links to the DE login anymore (that page is
             * unlisted; nothing in the UI may point at it). Everyone else gets NOTHING:
             * the old plain-text "for partners" tagline was decoration that collided
             * with the collapsed-nav hamburger, so external users see just the logo.
             */
            (props.isLoggedIn && (props.hasInternalPartnerRole || props.hasRoleAdminEmployer))
            && (
               <div className='d-inline ml-2 text-gray2'>
                  for
                  <div className='d-inline'>
                     <Button
                        aria-controls='simple-menu'
                        aria-haspopup='true'
                        onClick={ openEmployerMenu }
                        classes={{
                           label: 'text-lowercase',
                           root: 'outline-none pl-1 text-gray2',
                        }}
                     >
                        { sideLabel }
                        <i className='far fa-chevron-down ml-1'/>
                     </Button>
                     <Menu
                        id='simple-menu'
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={closeEmployerMenu}
                     >
                        <MenuItem onClick={closeEmployerMenu}>
                           <Link to='/employer'>
                              Employers
                           </Link>
                        </MenuItem>
                        {
                           props.hasRoleAdminEmployer
                           && (
                              <MenuItem onClick={closeEmployerMenu}>
                                 <Link
                                    to={{
                                       pathname: '/auth/login/jobcase',
                                       state: { from: '/job-feed/job-reporting' },
                                    }}
                                 >
                                    Partners
                                 </Link>
                              </MenuItem>
                           )
                        }
                     </Menu>
                  </div>
               </div>
            )
         }
         {
            (props.isLoggedIn || props.isLoggedInPartner)
            && (
               <>
                  {/* ml-3 keeps the toggle clear of the logo now that the "for
                      partners" tagline (the old implicit spacer) is gone */}
                  <span
                     className='sidebar-toggle d-flex ml-3 mr-2'
                     onClick={() => {
                        props.toggleSidebar();
                     }}
                  >
                     <i className='hamburger align-self-center'/>
                  </span>
                  <Collapse navbar>
                     <Nav className='ml-auto' navbar>
                        {
                           props.isLoggedIn
                           && !props.isImpersonatingPartner
                           && <OrganizationSwitch/>
                        }
                        <ImpersonationDropdown/>
                        <UserDropDownMenu/>
                     </Nav>
                  </Collapse>
               </>
            )
         }
      </Navbar>
   );
};

const mapStateToProps = (state) => {
   // TODO: remove after partner auth is released to prod for all roles
   const loggedInUserEmployerRoles = state?.authReducer?.loggedInUser?.roles || [];
   const hasRoleAdminEmployer = authUtil.userRolesInRolesVisibleTo(loggedInUserEmployerRoles, [employerRole.admin]);
   const loggedInUserPartnerRoles = state?.authReducer?.loggedInUserPartner?.roles || [];
   const hasInternalPartnerRole = authUtil.userRolesInRolesVisibleTo(
      loggedInUserPartnerRoles,
      [partnerRole.admin, partnerRole.employerCentralInternal],
   );
   return {
      isImpersonating: state.authReducer.loggedInUser.impersonating === 'true',
      isImpersonatingPartner: state.authReducer?.loggedInUserPartner?.impersonating,
      isLoggedIn: state.authReducer.isLoggedIn,
      isLoggedInPartner: state.authReducer?.isLoggedInPartner,
      hasRoleAdminEmployer,
      hasInternalPartnerRole,
   };
};

const mapDispathToProps = (dispatch) => ({
   toggleSidebar: () => {
      dispatch(toggleSidebar());
   },
});

export default connect(
   mapStateToProps,
   mapDispathToProps,
)(NavbarComponent);
